/*
 * Ryan O'Dowd
 * 2023-01-21
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  return {
    verseWrapper: {
      display: 'flex',
      flexDirection: 'column',
      borderLeftStyle: 'solid',
      borderLeftWidth: 2,
      color: colors.extraLightGray,
      borderLeftColor: colors.primaryExtraLight,
      marginBottom: globalScale * 16,
      padding: 8,
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 8,
    },
    verseBody: {
      fontFamily: fonts.primaryItalic,
      fontSize: globalScale * 12,
      display: 'inline',
      color: colors.white,
    },
    bold: {
      fontFamily: fonts.primaryBoldItalic,
      color: colors.accent,
    },
    reference: {
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 14,
      marginTop: 4,
      color: colors.white,
    },
    introText: {
      color: colors.white,
      marginBottom: globalScale * 16,
    },
    signInButton: {
      marginLeft: 8,
    },
    showAllToggle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.primary,
      cursor: 'pointer',
      paddingTop: 8,
      paddingBottom: 32,
      fontSize: 14,
    },
    controlsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: 8,
    },
    fullWidth: {
      flex: 1,
      justifySelf: 'center',
    },
    sortButtonWrapper: {
      width: 40,
      padding: 8,
    },
    addTranslationTextInput: {
      width: '100%',
    },
    searchBarWrapper: { // @TODO: should this be its own component?
      display: 'flex',
      width: 400,
      maxWidth: '100%',
      // @TODO: paddingTop: 8,
      paddingLeft: 16,
      // @TODO: paddingBottom: 8,
      paddingRight: 16,
      // @TODO: marginBottom: 32,
    },
    searchBar: { // @TODO: should this be its own component?
      display: 'flex',
      // @TODO: height: 40, // @TODO: maybe this is good for help component only
      fontFamily: fonts.primary,
    },
  };
};

export default getStyles;
